import {
  AuditConfig,
  BasicData,
  ServiceConfigResponse,
  XmlFilesContent,
} from 'models/husqiotbus';

type Directory = {
  directoryHandle: FileSystemDirectoryHandle | undefined;
};
const DIRECTORY: Directory = {
  directoryHandle: undefined,
};
export default DIRECTORY;

async function saveFile(
  blob: Blob,
  suggestedName: string,
  directoryHandle: FileSystemDirectoryHandle
) {
  const fileHandle = await directoryHandle.getFileHandle(suggestedName, {
    create: true,
  });
  const writable = await fileHandle.createWritable();
  await writable.write(blob);
  await writable.close();
}

export async function saveGeneratedXml(xml: XmlFilesContent) {
  const configDir = await getSubDirectory('config');
  const etcDir = await getSubDirectory('etc', configDir);
  const includeDir = await getSubDirectory('include', etcDir);
  const devDivertDir = await getSubDirectory('dev', includeDir);
  const qaDivertDir = await getSubDirectory('qa', includeDir);
  const liveDivertDir = await getSubDirectory('live', includeDir);
  // Save addresses.xml
  await saveFile(new Blob([xml.addresses]), 'addresses.xml', includeDir);
  // Save diverts.xml
  await saveFile(new Blob([xml.devDiverts ?? '']), 'diverts.xml', devDivertDir);
  await saveFile(new Blob([xml.qaDiverts ?? '']), 'diverts.xml', qaDivertDir);
  await saveFile(
    new Blob([xml.liveDiverts ?? '']),
    'diverts.xml',
    liveDivertDir
  );
  // Save extension.xml
  await saveFile(
    new Blob([xml.extension]),
    'husqiot-extension.xml',
    includeDir
  );
  // Save security.xml
  await saveFile(new Blob([xml.security]), 'security-settings.xml', includeDir);
}

export async function saveConfiguration(config: ServiceConfigResponse) {
  const configToolDir = await getSubDirectory('config-tool');
  const configDir = await getSubDirectory('configurations', configToolDir);
  await saveFile(
    new Blob([JSON.stringify(config)]),
    `${config.id}.json`,
    configDir
  );
}

export async function getSubDirectory(
  directoryName: string,
  directory?: FileSystemDirectoryHandle
): Promise<FileSystemDirectoryHandle> {
  const directoryHandle = directory ? directory : DIRECTORY.directoryHandle;
  if (!directoryHandle) {
    throw new Error(
      'Cant get sub directory, cause no FileSystemDirectoryHandle exists'
    );
  }
  const subdirTemplates = await directoryHandle.getDirectoryHandle(
    directoryName
  );
  return subdirTemplates;
}

export async function readFile(
  file: File
): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = reject;
    fileReader.readAsText(file);
  });
}

export async function readBasicData(): Promise<BasicData> {
  const directory = await getSubDirectory('config-tool');
  const files: File[] = await getFilesInDirectory(directory);
  const file = files.filter((file) => file.name === 'basic-data.json');
  const basicData = await readFile(file[0]);
  return JSON.parse(basicData as string);
}

export async function readAuditConfig(): Promise<AuditConfig> {
  const directory = await getSubDirectory('config-tool');
  const files: File[] = await getFilesInDirectory(directory);
  const file = files.filter((file) => file.name === 'audit-config.json');
  const basicData = await readFile(file[0]);
  return JSON.parse(basicData as string);
}

export async function getFilesInDirectory(
  directory: FileSystemDirectoryHandle
) {
  const files: File[] = [];
  for await (const entry of (directory as any).values()) {
    if (entry.kind === 'file') {
      const file = await entry.getFile();
      if (file !== null) {
        files.push(file);
      }
    }
  }
  return files.sort((a, b) => a.name.localeCompare(b.name));
}
